import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";

import PassedTable from "./PassedTable";
import ManualTable from "./ManualTable";
import SkippedTable from "./SkippedTable";

export default function ControlledAccordions(props) {
  const { overallAudit, manualAudit, skippedAudit, passedAudit } = props;

  const [expanded, setExpanded] = React.useState(false);

  const [manuallist, setManuallist] = React.useState([]);
  const handleManualChange = (panel) => (event, isExpanded) => {
    const auditID = window.sessionStorage.getItem("auditID");
    fetch(`${process.env.REACT_APP_API_URL}/api/auditmanualview/${auditID}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setManuallist(resp))
      .catch((error) => {
        console.error(error);
      });
    setExpanded(isExpanded ? panel : false);
  };

  const [skippedlist, setSkippedlist] = React.useState([]);
  const handleSkippedChange = (panel) => (event, isExpanded) => {
    const auditID = window.sessionStorage.getItem("auditID");
    fetch(`${process.env.REACT_APP_API_URL}/api/auditskippedview/${auditID}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setSkippedlist(resp))
      .catch((error) => {
        console.error(error);
      });
    setExpanded(isExpanded ? panel : false);
  };

  const [passedlist, setPassedlist] = React.useState([]);
  const handlePassedChange = (panel) => (event, isExpanded) => {
    const auditID = window.sessionStorage.getItem("auditID");
    fetch(`${process.env.REACT_APP_API_URL}/api/auditpassedview/${auditID}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setPassedlist(resp))
      .catch((error) => {
        console.error(error);
      });
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div>
      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleManualChange("panel1")}
      >
        <AccordionSummary
          expandIcon={<KeyboardDoubleArrowDownIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography sx={{ width: "33%", flexShrink: 0 }}>MANUAL</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <div className="col">
            <ManualTable
              manuallist={manuallist}
              overallAudit={overallAudit}
              manualAudit={manualAudit}
            />
          </div>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel2"}
        onChange={handleSkippedChange("panel2")}
      >
        <AccordionSummary
          expandIcon={<KeyboardDoubleArrowDownIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography sx={{ width: "33%", flexShrink: 0 }}>SKIPPED</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <div className="col">
            <SkippedTable
              skippedlist={skippedlist}
              overallAudit={overallAudit}
              skippedAudit={skippedAudit}
            />
          </div>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel3"}
        onChange={handlePassedChange("panel3")}
      >
        <AccordionSummary
          expandIcon={<KeyboardDoubleArrowDownIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <Typography sx={{ width: "33%", flexShrink: 0 }}>PASSED</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <div className="col">
            <PassedTable
              passedlist={passedlist}
              overallAudit={overallAudit}
              passedAudit={passedAudit}
            />
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}